<template>
  <div class="c">
    <header>
      <div>
        <p class="h-title">累计数据采集量</p>
        <p class="h-subtitle">
          <span class="h-subtitle-left">{{Number(gatherNumber).toLocaleString()}}</span>
          <span class="h-subtitle-right">亿条</span>
        </p>
      </div>
      <div>
        <p class="h-title">今日数据吞吐量</p>
        <p class="h-subtitle">
          <span class="h-subtitle-left">{{Number(dataNumber).toLocaleString()}}</span>
          <span class="h-subtitle-right">MB</span>
        </p>
      </div>
    </header>
    <section>
      <div class="s-left">
        <div class="s-l-top">
          <p class="s-l-student"></p>
          <ul class="s-ul-common ul-student">
            <li>
              <span class="title">今日新增</span>
              <p class="count">{{studentNewAddNumber}}</p>
            </li>
            <li>
              <span class="title">数据采集量</span>
              <p><span>{{Number(allStudent).toLocaleString()}}</span> <span>亿条</span></p>
            </li>
          </ul>
        </div>
        <div class="s-l-bottom">
          <p class="s-l-parent"></p>
          <ul class="s-ul-common ul-parent">
            <li>
              <span class="title">今日新增</span>
              <p class="count">{{teacherNewNumber}}</p>
            </li>
            <li>
              <span class="title">数据采集量</span>
              <p><span>{{Number(allTeacher).toLocaleString()}}</span> <span>亿条</span></p>
            </li>
          </ul>
        </div>
      </div>
      <div class="s-center">
        <p class="s-c-back"></p>
        <ul>
          <li class="s-c-one"></li>
          <li class="s-c-two"></li>
          <li class="s-c-three"></li>
          <li class="s-c-four"></li>
          <li class="s-c-five"></li>
        </ul>
      </div>
      <div class="s-right">
        <div class="s-r-top">
          <p class="s-r-teacher"></p>
          <ul class="s-ul-common ul-teacher">
            <li>
              <p class="title">今日新增</p>
              <p class="count">{{parentNewNumber}}</p>
            </li>
            <li>
              <p class="title">数据采集量</p>
              <p><span>{{Number(allParent).toLocaleString()}}</span> <span>亿条</span></p>
            </li>
          </ul>
        </div>
        <div class="s-r-bottom">
          <p class="s-r-school"></p>
          <ul class="s-ul-common ul-school">
            <li>
              <p class="title">今日新增</p>
              <p class="count">{{schoolNewNumber}}</p>
            </li>
            <li>
              <p class="title">数据采集量</p>
              <p><span>{{Number(allSchool).toLocaleString()}}</span> <span>亿条</span></p>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'SchoolBigData',
  data() {
    return {
      gatherNumber: 201875467,
      dataNumber: 5768934689,
      studentNewAddNumber: 768903,
      allStudent: 98790376,
      parentNewNumber: 498750,
      allParent: 50234562,
      teacherNewNumber: 329873,
      allTeacher: 30566754,
      schoolNewNumber: 174857,
      allSchool: 22284671,
      timer: '',
    };
  },
  mounted() {
    this.gatherNumber = this.allStudent + this.allTeacher + this.allParent + this.allSchool;
    this.mapTimer = setInterval(() => {
      const student = Math.ceil(Math.random() * 900 + 100);
      const teacher = Math.ceil(Math.random() * 900 + 100);
      const parent = Math.ceil(Math.random() * 900 + 100);
      const school = Math.ceil(Math.random() * 900 + 100);
      this.dataNumber += Math.ceil(Math.random() * 90000 + 10000);
      this.studentNewAddNumber += student;
      this.allStudent += student;
      this.teacherNewNumber += teacher;
      this.allTeacher += teacher;
      this.parentNewNumber += parent;
      this.allParent += parent;
      this.schoolNewNumber += school;
      this.allSchool += school;
      this.gatherNumber = this.allStudent + this.allTeacher + this.allParent + this.allSchool;
    }, 60000);
  },
  destroyed() {
    clearInterval(this.timer);
  },
};
</script>

<style lang="scss" scoped>
.c {
  width: 100%;
  height: 100%;
  overflow: hidden;
  header {
    width: 900px;
    height: 100px;
    margin: 34px auto;
    display: flex;
    justify-content: space-between;
    div {
      min-height: 105px;
      min-width: 390px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      .h-title {
        font-size: 22px;
        font-weight: 400;
        text-align: center;
      }
      .h-subtitle {
        height: 71px;
        line-height: 71px;
        margin-top: 12px;
        font-size: 40px;
        font-weight: bold;
        text-align: center;
        background: url("../../images/exhibition-data.png") no-repeat;
        background-size: cover;
        &-right {
          height: 71px;
          font-size: 26px;
          font-weight: 400;
          text-align: center;
        }
      }
    }
  }
  section {
    // display: flex;
    position: relative;
    .s-ul-common {
      box-sizing: border-box;
      padding-left: 20px;
      li {
        margin-bottom: 12px;
        .title {
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
        }
        .count {
          font-size: 40px;
          font-family: DINAlternate-Bold, DINAlternate;
          font-weight: bold;
          span {
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
          }
        }
      }
    }
    .s-left {
      position: absolute;
      width: 755px;
      height: 761px;
      background: url("../../images/exhibition-data_left.png") no-repeat;
      background-size: 755px 761px;
      .s-l-top {
        position: absolute;
        display: flex;
        top: 116px;
        left: 50px;
        .s-l-student {
          width: 100px;
          height: 118px;
          background: url("../../images/exhibition-student.png") no-repeat;
          background-size: 100px 118px;
        }
        .ul-student {
          color: #00DEFF;
        }
      }
      .s-l-bottom {
        position: absolute;
        display: flex;
        top: 567px;
        left: 50px;
        .s-l-parent {
          width: 100px;
          height: 118px;
          background: url("../../images/exhibition-parent.png") no-repeat;
          background-size: 100px 118px;
        }
        .ul-parent {
          color: #FF21FD;
        }
      }
    }
    .s-center {
      // flex: 1;
      position: absolute;
      top: 220px;
      left: 49%;
      transform: translateX(-50%);
      .s-c-back {
        width: 424px;
        height: 415px;
        background: url("../../images/exhibition-data_center.png") no-repeat;
        background-size: 424px 415px;
        z-index: 999;
      }
      ul {
        li {
          position: absolute;
          transform: translateX(-49%);
          z-index: -1;
        }
        .s-c-one {
          left: 47%;
          top: calc(54% - 38px);
          width: 76px;
          height: 76px;
          background: url("../../images/action_one.png") no-repeat;
          background-size: 76px;
        }
        .s-c-two {
          left: 23%;
          top: calc(54% - 102px);
          width: 205px;
          height: 205px;
          background: url("../../images/action_two.png") no-repeat;
          background-size: 205px;
          transform-origin: 50% 50%;
          animation: turn 5s linear infinite;
        }
        .s-c-three {
          left: 15%;
          top: calc(54% - 137px);
          width: 276px;
          height: 274px;
          background: url("../../images/action_three.png") no-repeat;
          background-size: 276px 274px;
          transform-origin: 50% 50%;
          animation: unturn 5s linear infinite;
        }
        .s-c-four {
          left: 48%;
          top: calc(52% - 174px);
          width: 371px;
          height: 360px;
          background: url("../../images/action_four.png") no-repeat;
          background-size: 371px 360px;
          // transform-origin:50% 50%;
          // animation: turn 5s linear infinite;
          // animation: turn 5s linear infinite;
        }
        .s-c-five {
          left: 30%;
          top: calc(50% - 193px);
          width: 260px;
          height: 387px;
          background: url("../../images/action_five.png") no-repeat;
          background-size: 260px 387px;
        }
        @keyframes turn {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
        @keyframes unturn {
          from {
            transform: rotate(360deg);
          }
          to {
            transform: rotate(0deg);
          }
        }
      }
    }
    .s-right {
      position: absolute;
      top: -86px;
      right: 50px;
      width: 741px;
      height: 850px;
      background: url("../../images/exhibition-data_right.png") no-repeat;
      background-size: 741px 850px;
      .s-r-top {
        position: absolute;
        display: flex;
        top: 265px;
        right: 30px;
        .s-r-teacher {
          width: 100px;
          height: 118px;
          background: url("../../images/exhibition-teacher.png") no-repeat;
          background-size: 100px 118px;
        }
        .ul-teacher {
          color: #FF2323;
        }
      }
      .s-r-bottom {
        position: absolute;
        display: flex;
        top: 640px;
        right: 30px;
        .s-r-school {
          width: 100px;
          height: 118px;
          background: url("../../images/exhibition-school.png") no-repeat;
          background-size: 100px 118px;
        }
        .ul-school {
          color: #FCE204;
        }
      }
    }
  }
}
</style>
